<template>
  <!-- SPINNER -->
  <div v-if="loadingSpiner" class="spiner-background">
    <div class="spiner-load" />
  </div>

  <!-- NOTIFICAÇÃO -->
  <transition name="fade">
    <div v-if="notificacao" class="notificao-background">
      <div class="notificao-dialog">
        <h1>{{ textoNotificacao }}</h1>
        <div class="buttons-action">
          <button class="outline" @click="fecharNotificacao">OK</button>
        </div>
      </div>
    </div>
  </transition>
  <router-view />
</template>

<script setup>
import { ref, provide } from 'vue'
import useAutoSendHeight from './composables/useAutoSendHeight'
if (window.self !== window.top) {
  function sendHeight () {
    const el = document.getElementById('agendar_seufisio')
    const height = (el?.scrollHeight || 0) + 72
    window.parent.postMessage({ type: 'resize', height }, '*')
  }

  useAutoSendHeight(sendHeight)
}

const loadingSpiner = ref(false)
const notificacao = ref(false)
const textoNotificacao = ref('')
const loading = {
  show: () => { loadingSpiner.value = true },
  hide: () => { loadingSpiner.value = false },
}

const mostrarNotificacao = (texto) => {
  textoNotificacao.value = texto
  notificacao.value = true
}
const fecharNotificacao = () => {
  notificacao.value = false
}

provide('loading', loading)
provide('mostrarNotificacao', mostrarNotificacao)
</script>

<style>

</style>
